import React, { useContext, useEffect } from 'react';
import { AppSettings } from './../../config/app-settings.js';
import Countdown from 'react-countdown';

function ExtraComingSoon() {
	const context = useContext(AppSettings);

	useEffect(() => {
		context.handleSetAppSidebarNone(true);
		context.handleSetAppHeaderNone(true);
		context.handleSetAppClass('app-without-header');
		context.handleSetAppContentClass('p-0');

		return () => {
			context.handleSetAppSidebarNone(false);
			context.handleSetAppHeaderNone(false);
			context.handleSetAppClass('');
			context.handleSetAppContentClass('');
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="coming-soon">
			<div className="coming-soon-header">
							<div className="bg-cover"></div>
							<div className="brand">
								<span className="logo"></span> <b>Color</b> Admin
							</div>
							<div className="desc">
								Our website is almost there and it’s rebuilt from scratch! A lot of great new features <span className="d-none d-sm-inline"><br /></span>and improvements are coming.
							</div>
							<div className="timer">
								<div id="timer">
									<Countdown
										date={Date.now() + 1000000000}
										renderer={(props) => (
											<div className="is-countdown">
												<span className="countdown-row countdown-show4">
													<span className="countdown-section"><span className="countdown-amount">{props.days}</span><span className="countdown-period">Days</span></span>
													<span className="countdown-section"><span className="countdown-amount">{props.hours}</span><span className="countdown-period">Hours</span></span>
													<span className="countdown-section"><span className="countdown-amount">{props.minutes}</span><span className="countdown-period">Minutes</span></span>
													<span className="countdown-section"><span className="countdown-amount">{props.seconds}</span><span className="countdown-period">Seconds</span></span>
												</span>
											</div>
										)}
									/>
								</div>
							</div>
						</div>
						
						
						<div className="coming-soon-content">
							<div className="desc">
								We are launching a closed <b>beta</b> soon!<br /> Sign up to try it before others and be the first to know when we <b>launch</b>.
							</div>
							<div className="form mb-2">
								<div className="form-control form-control-lg border-0 bg-body bg-opacity-75 d-flex align-items-center pe-6px">
									<iconify-icon icon="solar:letter-bold-duotone" className="fa-2x mx-n1 me-n2 text-body text-opacity-75"></iconify-icon>
									<input type="text" className="form-control form-control-lg fs-6 fw-semibold border-0 shadow-none bg-none flex-1 my-n2" placeholder="Enter your email address..." />
									<button type="button" className="btn my-n1 btn-dark">Notify Me</button>
								</div>
							</div>
							<p className="text-body text-opacity-50 fw-semibold mb-5">We don't spam. Your email address is secure with us.</p>
							<div className="flex-1 d-flex align-items-end justify-content-center">
								<span className="me-2">Follow us on</span>
								<a href="#/" className="mx-1 text-decoration-none link-dark">
									<i className="fab fa-twitter fa-lg fa-fw opacity-3"></i> Twitter
								</a> 
								<a href="#/" className="mx-1 text-decoration-none link-dark">
									<i className="fab fa-facebook-square fa-lg fa-fw opacity-3"></i> Facebook
								</a>
							</div>
						</div>
		</div>
	);
}

export default ExtraComingSoon;
